import React from "react";
import {RatesTable} from "./RatesTable";

const ProjectSearchRatesTab = ({
                                  loading,
                                  ratesResponse
                                }) => {
  return (
    <>
      <RatesTable
        rates={ratesResponse.rates}
        exports={ratesResponse.exports}
        loading={loading}
      />
    </>
  );
}

export {ProjectSearchRatesTab};